/**
 * Step records may carry routeName from the DB/CMS. Only allow known app paths.
 * Keep in sync with API/src/v1/utils/helpers/safeStepRouteName.js
 */

const ALLOWED_STEP_PATHS = new Set([
  "/create-book",
  "/dashboard",
  "/review",
  "/create",
  "/cover-image",
  "/shopify-cart",
  "/my-orders",
]);

function pathnameOnly(routeName) {
  if (!routeName || typeof routeName !== "string") return "";
  const t = routeName.trim();
  return t.split("?")[0].split("#")[0];
}

export function isSafeStepRouteName(routeName) {
  const pathOnly = pathnameOnly(routeName);
  if (!pathOnly.startsWith("/")) return false;
  if (pathOnly.includes("..")) return false;
  if (pathOnly.includes("//")) return false;
  if (pathOnly === "/auth" || pathOnly.startsWith("/auth/")) return false;
  if (pathOnly.startsWith("/api")) return false;
  return ALLOWED_STEP_PATHS.has(pathOnly);
}

export function safeStepDestination(routeName, stepCode) {
  if (!stepCode && stepCode !== 0) return "/dashboard";
  if (!isSafeStepRouteName(routeName)) return "/dashboard";
  const pathOnly = pathnameOnly(routeName);
  return `${pathOnly}?stepCode=${encodeURIComponent(String(stepCode))}`;
}
